import {get, postWithHeaders,postWithHeadersResponse,patch} from "../../../server/actions";
export const getPackageList=(schoolId, schoolYear)=>{
    return get(`/schoolPackages/search/findByMealSchoolSchoolIdAndSchoolYearAndIsActive?mealSchoolId=${schoolId}&schoolYear=${schoolYear}&isActive=true&access_token=`);
}
export const getStudentsPackageDetails=(schoolId, currentDate, parent)=>{
    return get(`/reports/bcacKidsSubsPkg?mealSchoolId=${schoolId}&parentEmail=${parent}&currentDate=${currentDate}&access_token=`);
}
export const saveStudentsPackageDetails=(req)=>{
    let headers = {
        'Content-Type': 'application/json'
    };
    return postWithHeaders("/transactions/subscribePackage?access_token=", JSON.stringify(req),headers);
}
export const saveAuthorizedPersons=(req)=>{
    let headers = {
        'Content-Type': 'application/json'
    };
    return postWithHeaders("/transactions/authorizePP?access_token=", JSON.stringify(req),headers);
}


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/bcacServices.js